import './component.css';

$(() => $('.toggle-details').on('click', (e) => $(e.currentTarget).toggleClass('show')));



// WEBPACK FOOTER //
// ./app/components/class_details/component.js